<template>
  <div class="cases-center_box">
    <div class="cases-title">
      <div class="case-type-box">
        <ul class="case-type">
          <li class="case-li">行业分类：</li>
          <li
            @mouseenter="mouseEnter(0)"
            @mouseleave="mouseLeave"
            @click="caseType(0)"
            :class="{ active: 0 == selectId }"
          >
            全部
          </li>
          <li
            @mouseenter="mouseEnter(item.id)"
            @mouseleave="mouseLeave"
            @click="caseType(item.id)"
            v-for="item in typeList"
            :key="item.id"
            :class="{ active: item.id == selectId }"
          >
            {{ item.title }}
          </li>
        </ul>
        <div class="label_box">
          <div class="label_left">标签分类：</div>
          <ul class="case-type case-type2">
            <!-- <li class="case-li">
          标签分类:
      </li> -->
            <li
              @mouseenter="mouseEnter(0)"
              @mouseleave="mouseLeave"
              @click="caseLabel(0)"
              :class="{ active: labelselectId.indexOf(0) >= 0 }"
            >
              全部
            </li>
            <li
              @mouseenter="mouseEnter(item.id)"
              @mouseleave="mouseLeave"
              @click="caseLabel(item.id)"
              v-for="item in labelList"
              :key="item.id"
              :class="{ active: labelselectId.indexOf(item.id) >= 0 }"
            >
              {{ item.title }}
            </li>
          </ul>
        </div>
      </div>
      <!-- <h2>经典案例</h2>
      <h6>6年行业沉淀、800多家高端客户见证，一匠为您提供优质的产品和高质量的服务</h6> -->
      <!-- v-if="showSwiper" -->
      <!-- <div class="swiperBox"  >
        <div class="swiper-container" >
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item,index) in caseDetail.top" :key="index">
              <div class="swiperList">
                <div class="caseLogo">
                  <img  :src="item.cover_image" alt=""/>
                </div>
                <div class="caseIntro">
                  <h3>{{item.title}}</h3>
                  <h5>{{item.service_brand}}</h5>
                  <h4>业务类型<span>{{item.industry_id}}</span></h4>
                  <h4 class="intoCont">客户介绍<span>{{item.dir}}</span></h4>
                  <div class="swiperOpera">
                    <p class="lookBtn"  @click="link(item)">查看详情》》</p>
                    <div class="swiperPage">
                    <span>{{index+1}}</span>  /  {{caseDetail.top.length}}
                    </div>
                  </div> 
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
      </div> -->
    </div>
    <div class="cases-center">
      <div class="caseTypeBox">
        <div class="cases-swiper-container" ref="casesPages">
          <div class="cases-show">
            <ul>
              <li
                @mouseenter="open(item.id)"
                @mouseleave="close(item.id)"
                v-for="item in caseDetail.data"
                :key="item.id"
                @click="link(item)"
              >
                <img :src="item.cover_image" alt="" />
                <div class="swaipCaseIntro">
                  <h3>
                    <p>{{ item.title }}</p>
                    <div class="caseTypeIntro">{{ item.cate }}</div>
                  </h3>
                  <div class="detail_label">
                    <h6>
                      <span>服务品牌：{{ item.service_brand }}</span>
                    </h6>
                    <div class="detail_label_list">
                      <span
                        class="detail_label_item"
                        v-for="(item2, index) in item.industry_label_ids"
                        :key="index"
                      >
                        {{ item2 }}
                      </span>
                    </div>
                  </div>
                </div>
                <transition>
                  <div v-show="item.id == actCase" class="abso">
                    <img :src="item.qr_image" alt="" v-if="item.qr_image" />
                    <p v-else>
                      <span>{{ item.title }}</span>
                    </p>
                  </div>
                </transition>
              </li>
            </ul>
          </div>
        </div>
        <!-- <div v-if="caseDetail.rows.length<15">没有更多啦。。。</div> -->
        <div class="cases-button">
          <i class="iconfont icon-jiantouzuo" @click="prePage()"></i
          >{{ page }}/{{ caseDetail.last_page
          }}<i class="iconfont icon-icon_arrow_right" @click="nextPage()"></i>
        </div>
        <!-- <div class="cases-swiper-pagination"></div> -->
      </div>
      <div class="advisoryBox">
        <img class="adIcon" src="../../static/images/zixun1.png" alt="" />
        <div class="bottomBox">
          <div class="bottomIntro">
            一匠为企业提供 &nbsp;&nbsp;<span>专业知识</span>&nbsp;&nbsp;
            和&nbsp;&nbsp; <span>创新技术</span>&nbsp;&nbsp;
            ，助力企业AI转型
          </div>
          <div class="bottomSelect">
            <h5>AI落地，就选一匠</h5>
            <h6>免费咨询热线： <span>13824289487</span></h6>
          </div>
        </div>
        <div class="btnAd" @click="jumpService">立即咨询</div>

        <!-- <img src="../../static/images/zixun1.png" alt="" > -->
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
export default {
  name: "CasesCenter",
  props: {
    type: Array,
    cases: Array,
    caseBanner: {
      type: Array,
      default: () => [],
    },
  },

  beforeMount() {
    //每次进入都会执行
    this.imgSwiper();
    this.getCaseList();
    this.getTypeList();
    this.getlabelList();
  },
  created() {
    // console.log(this.caseData)
  },
  mounted() {},
  data() {
    return {
      enterIndex: -1,
      actCase: -1,
      caseData: [],
      selectId: 0, //选中分类的id
      labelselectId: [0], //选中标签
      typeList: [], //分类的id
      labelList: [], //标签分类
      page: 1, //当前页
      caseArr: {},
      caseDetail: {
        top: [],
      }, //详情数据
    };
  },
  methods: {
    //上一页
    prePage() {
      if (this.page > 1) {
        this.page -= 1;
        this.getCaseList();
        window.scrollTo(0, 0);
      }
    },
    //下一页
    nextPage() {
      if (this.caseDetail.data.length >= 15) {
        this.page += 1;
        this.getCaseList();
        window.scrollTo(0, 0);
      }
    },
    //立即咨询
    jumpService() {
      this.$addConsult()
    },
    //获取新的详情
    getCaseList() {
      let params = {
        industry_id: this.selectId,
        label_id: this.labelselectId.join(),
        limit: 15,
        page: this.page,
      };
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/case_list",
        params,
        (res) => {
          // console.log(res.data,'res.data')
          this.caseDetail = res.data;
        }
      );
    },
    //获取分类列表
    getTypeList() {
      let params = {};
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/industry",
        params,
        (res) => {
          this.typeList = res.data;
        }
      );
    },
    //获取标签列表
    getlabelList() {
      let params = {};
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/vocationtag",
        params,
        (res) => {
          // console.log("res",res);
          this.labelList = res.data.reverse();
        }
      );
    },

    //跳转链接
    link(item) {
      // console.log(item)
      if (item.link_url != "") {
        window.open(item.link_url, "_blank");
        // window.location.href = item.link
        // return
      } else {
        // this.$router.push('/casedetail/'+item.id)
        const url = this.$router.resolve("/casedetail/" + item.id);
        window.open(url.href, "_blank");
      }
    },
    //选中的分类
    caseType(id) {
      if (this.selectId == id) {
        return;
      } else {
        this.selectId = id;
        this.page = 1;
        this.getCaseList();
      }
    },
    // 标签选中
    caseLabel(id) {
      // 判断是否点击全部
      if (id == 0) {
        this.labelselectId = [0];
      } else {
        if (this.labelselectId.indexOf(0) >= 0) {
          this.labelselectId = [];
        }
        let index = this.labelselectId.indexOf(id);
        if (index >= 0) {
          this.labelselectId.splice(index, 1);
        } else {
          if (this.labelselectId.length < 4) {
            this.labelselectId.push(id);
          }
        }
      }
      this.page = 1;
      this.getCaseList();
    },
    caseTypeArr() {
      for (var i = 0; i < this.cases.length; i++) {
        var type = this.cases[i].cate;
        if (!this.caseArr[type]) {
          this.caseArr[type] = [];
        }
        this.caseArr[type].push(this.cases[i]);
      }
      this.caseArr.all = this.cases;
    },
    open(id) {
      this.actCase = id;
      // this.$refs.casesPages.getElementsByTagName('li')[id].getElementsByTagName('div')[0].className = "highlight"
    },
    close(id) {
      this.actCase = -1;
      // this.$refs.casesPages.getElementsByTagName('li')[id].getElementsByTagName('div')[0].className = ""
    },
    mouseEnter(index) {
      this.enterIndex = index;
    },
    mouseLeave() {
      this.enterIndex = -1;
    },
    imgSwiper() {
      var mySwiper = new Swiper(".swiper-container", {
        slidesPerView: 1,
        lazyLoading: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        spaceBetween: 0,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        // pagination: {
        //     el: '.cases-swiper-pagination',
        //     type: 'fraction'
        // },
        onSlideChangeEnd: function (swiper) {
          swiper.update();
          mySwiper.startAutoplay();
          mySwiper.reLoop();
        },
      });
    },
  },

  computed: {
    pages() {
      const pages = [];
      if (!this.caseData) return pages;
      this.caseData.forEach((item, index) => {
        const page = Math.floor(index / 12);
        if (!pages[page]) pages[page] = [];
        pages[page].push(item);
      });
      return pages;
    },
    // showSwiper() {
    //   return this.caseDetail.top.length;
    // },
  },
  watch: {
    cases(newVal) {
      this.caseData = newVal;
      this.caseTypeArr();
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varible.styl';
@import '~styles/mixins.styl';

.cases-center >>> .swiper-button-disabled {
  color: #999 !important;
}

.cases-center >>> .swiper-pagination-fraction {
  color: #666 !important;
}

.swiperBox {
  width: 1100px;
  margin: 0 auto;

  .swiper-slide {
    width: 1100px;
  }

  .swiperList {
    display: flex;
    justify-content: flex-start;
    width: 920px;
    height: 300px;
    overflow: hidden;
    box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.2);
    border-radius: 2px;
    margin: 20px auto;
  }

  .caseIntro {
    width: 430px;
    text-align: left;

    h3 {
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      line-height: 28px;
      padding: 30px 0;
    }

    h5 {
      font-size: 16px;
      font-weight: bold;
      color: #333333;
      line-height: 28px;
    }

    h4 {
      display: flex;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 22px;
      margin: 10px auto;

      span {
        font-size: 16px;
        font-weight: bold;
        color: #333333;
        line-height: 28px;
        padding: 0 0 0 15px;
      }
    }

    .intoCont {
      height: 80px;

      span {
        width: 373px;
        height: 80px;
        text-overfloe: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        display: table-cell;
        vertical-align: middle;
        overflow: hidden;
      }
    }
  }

  .lookBtn {
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 28px;
  }

  .lookBtn:hover {
    color: #FFC000;
  }

  .swiperOpera {
    display: flex;
    justify-content: space-between;

    .swiperPage {
      font-size: 16px;
      font-weight: bold;
      font-style: italic;
      color: #999999;
      line-height: 28px;

      span {
        font-size: 18px;
        color: #FFC000;
      }
    }
  }

  .caseLogo {
    width: 420px;
    margin: 0 30px 0 0;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.caseTypeBox {
  padding: 20px 3% 190px;
  background-color: #f5f5f5;
}

.cases-title {
  position: relative;
  width: 100%;
  background-color: #fff;
  padding: 37px 0 32px 0;

  h2 {
    font-size: 30px;
    font-weight: bold;
    color: #333333;
    line-height: 28px;
    font-size: 42px;
    margin: -0.5em 0 0 -2em;
    letter-spacing: 2px;
    color: #333;

    &:after {
      content: '';
      position: absolute;
      margin-left: -60px;
      display: block;
      border-bottom: 1px solid #F5BA1A;
      width: 42px;
      margin-top: 26px;
      left: 50%;
    }
  }

  h6 {
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 28px;
    margin: 30px auto 10px;
  }
}

.case-type-box {
  box-sizing: border-box;
  // width: 100%;
  max-width: 1920px;
  // min-width: 1440px;
  margin: 0 auto;
  padding: 0 5%;
}

.label_box {
  margin-top: 20px;
  display: flex;
}

.label_left {
  width: 92px;
  flex-shrink: 0;
  font-size: 14px;
}

.case-type-box .case-type2 {
  // margin-top:20px;
  position: relative;
}

.case-type {
  .case-li {
    cursor: default;
    margin-left: 0;
  }

  li {
    display: inline-block;
    height: 22px;
    line-height: 22px;
    font-size: 14px;
    cursor: pointer;
    color: #333333;
    margin: 0 17px;
    border-radius: 2px;
  }

  .active {
    background: rgba(255, 192, 0, 0.1);
    color: #FFC000;
  }
}

.cases-center_box {
  background-color: #f5f5f5;
}

.detail_label {
  display: flex;
  justify-content: space-between;
}

.detail_label_list {
}

.detail_label_item {
  display: inline-block;
  height: 24px;
  line-height: 24px;
  background: #F5F5F5;
  border-radius: 2px;
  margin: 0 4px;
  font-size: 14px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: #666666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 68px;
}

.cases-center {
  box-sizing: border-box;
  text-align: center;
  width: 100%;
  max-width: 1920px;
  min-width: 1440px;
  margin: 0 auto;
  // padding: 5% 3% 190px
  background-color: #f5f5f5;

  .cases-swiper-container {
    overflow: hidden;

    .cases-show {
      box-sizing: border-box;
      width: 100%;
      padding: 0 2%;
      margin-top: 30px;
      overflow: hidden;

      li {
        position: relative;
        width: 32%;
        float: left;
        margin: 0 2% 2% 0;
        background: #fff;
        padding-bottom: 22.8%;
        overflow: hidden;
        height: 423px;
        cursor: pointer;

        img {
          width: 440px;
          height: 313px;
        }

        .swaipCaseIntro {
          margin: 27px 24px 23px 32px;
          text-align: left;

          h3 {
            display: flex;
            justify-content: space-between;

            p {
              font-size: 18px;
              font-weight: bold;
              color: #333333;
              line-height: 28px;
            }

            .caseTypeIntro {
              background: rgba(255, 192, 0, 0.05);
              border-radius: 2px;
              font-size: 14px;
              font-weight: 400;
              color: #C39A1D;
              line-height: 28px;
              padding: 5px 8px;
            }
          }

          h6 {
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            line-height: 28px;
          }
        }
      }

      li:nth-of-type(3n) {
        margin-right: 0;
      }

      .abso {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        background: $black;
        opacity: 0.9;

        img {
          position: absolute;
          width: 35%;
          right: 0;
          left: 0;
          top: 0;
          bottom: 0;
          margin: auto;
          height: auto;
          cursor: default;
        }

        p {
          position: absolute;
          width: 100%;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
          font-size: 22px;
          color: $yellow;
          cursor: pointer;

          span {
            position: absolute;
            display: block;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            margin: auto;
            height: 1em;
          }

          &:before {
            position: absolute;
            display: block;
            content: '';
            width: 6em;
            border-top: 1px solid $yellow;
            left: 7%;
            top: 50%;
          }

          &:after {
            position: absolute;
            display: block;
            content: '';
            width: 6em;
            border-top: 1px solid $yellow;
            right: 7%;
            top: 50%;
          }
        }
      }
    }
  }

  .cases-button {
    display: inline-block;
    margin: 82px auto 41px;
    font-size: 14px;
    background: #000;
    color: #fff;
    line-height: 60px;

    i {
      color: #fff;
      padding: 0 2.4em;
      font-size: 12px;
      cursor: pointer;
      outline: none;
    }
  }
}

.bottomBox {
  padding: 26px 118px 0 58px;
}

.advisoryBox {
  display: flex;
  justify-content: center;
  background: #FFC000;
  height: 136px;
  position: relative;

  .bottomIntro {
    font-size: 20px;
    font-weight: bold;
    color: #12161B;
    margin: 0 0 36px 0;
    line-height: 20px;

    span {
      color: #fff;
    }
  }

  .bottomSelect {
    display: flex;
    justify-content: space-between;

    h5 {
      font-size: 26px;
      font-weight: 400;
      color: #12171A;
      line-height: 20px;
    }

    h6 {
      font-size: 26px;
      font-weight: 400;
      color: #12171A;
      line-height: 20px;

      span {
        font-size: 38px;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 20px;
      }
    }
  }

  .btnAd {
    width: 120px;
    height: 52px;
    margin: 42px 0;
    background: #12171A;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 52px;
  }

  .adIcon {
    position: relative;
    top: -70px;
    width: 179px;
    height: 170px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/CaseCenterNew.vue